import React from "react";
import Modal from "./modal";
import UserCollectionRecord from "models/view-models/user-collection-record";
import Loader from "atoms/loaders/loader";
import { ModalTypes } from "molecules/constants/modal-types";
import BookmarkCollectionMultiSelect from "organisms/my-link/my-bookmarks/bookmark-collection-multi-select";
import { t } from "utilities/localization-utils";
import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import { IconSizes } from "atoms/constants/icon-sizes";
import Heading from "atoms/typography/heading";
import { HeadingPriority } from "atoms/constants/heading-priority";
import useBreakpoint from "utilities/hooks/use-breakpoint";
import { Breakpoints } from "utilities/enumerations/breakpoints";
import { ModalCloseButtonStyle } from "molecules/constants/modal-close-button-style";

interface UpdateBookmarkCollectionsModalProps {
    allCollections: UserCollectionRecord[];
    handleCollectionUpdate: (collections: UserCollectionRecord[]) => void;
    collectionsToUpdate: UserCollectionRecord[];
    onSave: () => void;
    toggleModal: () => void;
    showModal: boolean;
    isSaving: boolean;
}

const CSS_CLASS_NAME = "c-update-bookmark-collections-modal";

const UpdateBookmarkCollectionsModal = (
    props: UpdateBookmarkCollectionsModalProps
) => {
    const {
        isSaving,
        allCollections,
        handleCollectionUpdate,
        collectionsToUpdate,
        onSave,
        toggleModal,
        showModal,
    } = props;

    const isDesktop = useBreakpoint(Breakpoints.SmallDesktop);
    const modalType = isDesktop ? ModalTypes.Base : ModalTypes.Bottom;

    return (
        <Modal
            cssClassName={CSS_CLASS_NAME}
            closeDialog={toggleModal}
            isVisible={showModal}
            label={t("addOrRemoveFromYourCollections")}
            type={modalType}
            closeButtonStyle={ModalCloseButtonStyle.Hidden}>
            <header className={`${CSS_CLASS_NAME}__header`}>
                <Heading
                    priority={HeadingPriority.Three}
                    cssClassName={`${CSS_CLASS_NAME}__title`}>
                    {t("addOrRemoveFromYourCollections")}
                </Heading>
                <Button
                    cssClassName={`${CSS_CLASS_NAME}__closeX`}
                    accessibleText={t("cancel")}
                    onClick={toggleModal}
                    size={ButtonSizes.Medium}
                    style={ButtonStyles.None}>
                    <Icon type={Icons.Close} size={IconSizes.Large} />
                </Button>
            </header>
            <div className={`${CSS_CLASS_NAME}__body`}>
                {isSaving ? (
                    <Loader />
                ) : (
                    <BookmarkCollectionMultiSelect
                        allCollections={allCollections}
                        onChange={handleCollectionUpdate}
                        value={collectionsToUpdate}
                    />
                )}
            </div>
            <footer className={`${CSS_CLASS_NAME}__footer`}>
                <Button onClick={onSave}>{t("save")}</Button>
                <Button onClick={toggleModal} style={ButtonStyles.Secondary}>
                    {t("cancel")}
                </Button>
            </footer>
        </Modal>
    );
};

export default UpdateBookmarkCollectionsModal;
